"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const responsive_utils_1 = require("@zapier/responsive-utils");
const common_components_1 = require("@zapier/common-components");
const stepTitleSectionCss = {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'auto',
    padding: '0 10px 0 18px',
    textAlign: 'left',
};
const editableStepTitleCss = {
    display: 'inline-block',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '1.3em',
    padding: '5px 0',
    textAlign: 'left',
    verticalAlign: 'middle',
    width: '100%',
};
const StepTitleSection = ({ defaultTitle, isEditingStepTitle, isZapTemplate, label, onCommitStepTitle, stepNumber, subtitle, title, }) => {
    const [temporaryStepTitle, setTemporaryStepTitle] = react_1.useState(title || defaultTitle);
    const { isMobile } = responsive_utils_1.useMediaProps({
        [theme_1.Screen.queries.phoneOnly]: {
            isMobile: true,
        },
    });
    const shouldShowSubtitle = subtitle !== label;
    return (common_utils_1.isolateComponent("div", { css: stepTitleSectionCss },
        shouldShowSubtitle && (common_utils_1.isolateComponent(design_system_1.Text, { color: "grey700", type: "altText900" }, subtitle)),
        !isEditingStepTitle && !isZapTemplate && (common_utils_1.isolateComponent(design_system_1.Text, { type: shouldShowSubtitle ? 'subtitle800' : 'subtitle900' }, isMobile ? (`${stepNumber}. ${label}`) : (common_utils_1.isolateComponent(common_components_1.TruncatedText, null,
            stepNumber,
            ". ",
            label)))),
        isZapTemplate && common_utils_1.isolateComponent(design_system_1.Text, { type: "subtitle800" }, label),
        isEditingStepTitle && (common_utils_1.isolateComponent("span", { css: editableStepTitleCss },
            common_utils_1.isolateComponent(common_components_1.InlineEditor, { defaultIsEditing: true, iconTitle: "Edit step title", onChange: (name) => setTemporaryStepTitle(name), onClose: onCommitStepTitle, placeholder: title || defaultTitle, value: temporaryStepTitle })))));
};
const FastStepTitleSection = react_1.memo(StepTitleSection);
exports.default = FastStepTitleSection;
